import React, { useEffect } from "react"

import {
  DatoCmsAllLocalesForDatoCmsArticleSlug,
  DatoCmsSlugsConfiguration,
  FooterFieldsFragment,
  HeaderConfidentialityPolicyFieldsFragment,
  HeaderContactFieldsFragment,
  HeaderCookiesFieldsFragment,
  HeaderCreditsFieldsFragment,
  HeaderFieldsFragment,
  HeaderLegalMentionsFieldsFragment,
  HeaderNotFoundFieldsFragment,
  HeaderOurApproachFieldsFragment,
  HeaderPniFieldsFragment,
} from "../../../graphql-types"

import * as config from "../../../config.js"
import * as styles from "./layout.module.scss"
import { LocaleProvider } from "../../context/locale-context"
import Header, { enableDidomi, enableGoogleTagManagerBody } from "./header/header"
import Footer from "./footer/footer"
import HeaderGeneric from "./header-generic/header-generic"

type LayoutProps = {
  children?: React.ReactNode
  pageContext: {
    locale: string
    defaultLocale: string
    slugs: DatoCmsSlugsConfiguration
  }
  allSlugLocales?: [DatoCmsAllLocalesForDatoCmsArticleSlug]
  breadcrumb?: { link: string; title: string }[]
  currentRoute: string
  headerConfig?: HeaderFieldsFragment
  headerGenericConfig?:
    | HeaderPniFieldsFragment
    | HeaderOurApproachFieldsFragment
    | HeaderContactFieldsFragment
    | HeaderLegalMentionsFieldsFragment
    | HeaderConfidentialityPolicyFieldsFragment
    | HeaderCookiesFieldsFragment
    | HeaderCreditsFieldsFragment
    | HeaderNotFoundFieldsFragment
  headerDarkMode?: boolean
  footerConfig: FooterFieldsFragment
  footerBorderless?: boolean
  noIndex?: boolean
}

const Layout: React.FC<LayoutProps> = ({
  children,
  pageContext,
  allSlugLocales,
  breadcrumb,
  currentRoute,
  headerConfig,
  headerGenericConfig,
  headerDarkMode,
  footerConfig,
  footerBorderless,
  noIndex,
}) => {
  useEffect(() => {
    enableDidomi()
    config.google_tag_manager_id && enableGoogleTagManagerBody()
  }, [])

  return (
    <LocaleProvider locale={pageContext.locale} defaultLocale={pageContext.defaultLocale}>
      <div className={styles.globalWrapper} data-datocms-noindex={noIndex}>
        {headerConfig && <Header data={headerConfig} slugs={pageContext.slugs} currentRoute={currentRoute} allSlugLocales={allSlugLocales} />}
        {headerGenericConfig && (
          <HeaderGeneric
            data={headerGenericConfig}
            slugs={pageContext.slugs}
            allSlugLocales={allSlugLocales}
            breadcrumb={breadcrumb}
            currentRoute={currentRoute}
            darkMode={headerDarkMode}
          />
        )}
        <main id="main" role="main" tabIndex={-1}>
          {children}
          <Footer data={footerConfig} slugs={pageContext.slugs} borderless={footerBorderless} />
        </main>
      </div>
    </LocaleProvider>
  )
}

export default Layout
